import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

import { IS_AU, IS_UK, jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

import { TextLink } from "./components"

const country = () => sl.config.site_country_for_analytics.toLowerCase()
const customerServiceLink = () =>
  `https://www.klarna.com/${sl.config.site_country}/customer-service/`
const klarnaAppLink = () =>
  `https://www.klarna.com/${sl.config.site_country}/klarna-app/`
const termsLink = () =>
  IS_UK()
    ? `https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_${country()}/slice_it_card`
    : `https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_${country()}/paylaterin4`

const FooterPayIn3 = () => {
  return (
    <Box fontSize={12} mx={{ _: 2, tablet: "170px" }} my={5} textAlign="center">
      <Typography fontSize={12} id="plan-pricing">
        * You must be 18+ to use Klarna credit offers. Pay in 3 available on
        purchases between {to_currency(sl.config.klarna_min)} and{" "}
        {to_currency(sl.config.klarna_max)}; a higher initial payment may be
        required for some consumers. Pay in 3 complete{" "}
        <TextLink href={`${termsLink()}`} target="_blank">
          terms
        </TextLink>
        . Please note that Klarna is an independent payment company and{" "}
        {sl.config.site_title} has no influence over whether payments are
        accepted or not. Visit Klarna&apos;s website{" "}
        <TextLink href={customerServiceLink()} target="_blank">
          here
        </TextLink>{" "}
        or{" "}
        <TextLink href={klarnaAppLink()} target="_blank">
          download the app
        </TextLink>{" "}
        to speak with customer service.
      </Typography>
    </Box>
  )
}
const FooterPayIn4 = () => {
  return (
    <Box fontSize={12} mx={{ _: 2, tablet: "170px" }} my={5} textAlign="center">
      <Typography fontSize={12} id="plan-pricing">
        * You must be 18+ to use Klarna credit offers. Pay in 4 available on
        purchases between {to_currency(sl.config.klarna_min)} and{" "}
        {to_currency(sl.config.klarna_max)}; a higher initial payment may be
        required for some consumers.{" "}
        {!IS_AU()
          ? "See Pay in 4"
          : `Pay Later in 4 ${jewlr_t("terms.instalment")}s`}{" "}
        complete{" "}
        <TextLink href={`${termsLink()}`} target="_blank">
          terms
        </TextLink>
        . Please note that Klarna is an independent payment company and{" "}
        {sl.config.site_title} has no influence over whether payments are
        accepted or not. Visit Klarna&apos;s website{" "}
        <TextLink href={customerServiceLink()} target="_blank">
          here
        </TextLink>{" "}
        or{" "}
        <TextLink href={klarnaAppLink()} target="_blank">
          download the app
        </TextLink>{" "}
        to speak with customer service.
      </Typography>
    </Box>
  )
}

const Footer = ({ payIn4 }) => {
  return payIn4 ? <FooterPayIn4 /> : <FooterPayIn3 />
}

Footer.propTypes = {
  payIn4: PropTypes.bool,
}

export default Footer
